import { put, takeEvery } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import {
  queryDownloadIdsSuccess,
  queryDownloadIdsFailure,
  updateDownloadIds,
} from '../actions';
import DirectDownloadActionTypes from '../types';
import { downloadFile } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

export function* queryAllDownloadIds({ payload: { ids, allIds } }) {
  const response = yield Promise.all(
    ids.map(async (downloadId) => {
      const apiResponse = await request({
        method: 'get',
        url: `${API_BASE_URL}/tasks/${downloadId?.id}`,
      });
      return apiResponse;
    })
  );

  if (response[0].success) {
    const readyForDownload = response
      ?.filter((res) => res?.raw?.complete === true)
      ?.map((res) => res?.raw);
    const filterOutDownloadedIds = allIds.filter(
      (item) => !readyForDownload.find((element) => element.id === item?.id)
    );
    yield put(queryDownloadIdsSuccess());
    yield put(updateDownloadIds(filterOutDownloadedIds));
    for (let i = 0; i < readyForDownload.length; i++) {
      downloadFile(
        `${API_BASE_URL}${readyForDownload[i].result}`,
        +decodeURIComponent(readyForDownload[i].result.split('/').pop())
      );
    }
  } else {
    Notify(`Failed to download: ${response.message}`, {
      position: 'top-right',
      status: 'error',
    });
    yield put(queryDownloadIdsFailure(response.message));
  }
}

export function* onQueryDownloadIds() {
  yield takeEvery(
    DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_START,
    queryAllDownloadIds
  );
}
